module.exports = __webpack_public_path__ + "img/12-2.c525d254.png";